import { HttpErrorResponse } from '@angular/common/http';

const asRecord = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : null;

export const extractBackendErrorMessage = (error: unknown): string | null => {
  const responseError = asRecord(asRecord(error)?.error);
  const abpError = asRecord(responseError?.error);
  const validationErrors = Array.isArray(abpError?.validationErrors)
    ? abpError.validationErrors
    : [];

  const validationMessage = validationErrors
    .map(item => asRecord(item)?.message)
    .find((message): message is string => typeof message === 'string' && !!message.trim());

  const candidates = [
    abpError?.message,
    responseError?.message,
    asRecord(error)?.message,
    validationMessage,
  ];

  const message = candidates.find(
    (candidate): candidate is string => typeof candidate === 'string' && !!candidate.trim(),
  );

  return message?.trim() ?? null;
};

export const extractBackendErrorCode = (error: unknown): string | null => {
  const responseError = asRecord(asRecord(error)?.error);
  const abpError = asRecord(responseError?.error);
  const candidates = [
    abpError?.code,
    responseError?.code,
    asRecord(error)?.code,
  ];

  const code = candidates.find(
    (candidate): candidate is string => typeof candidate === 'string' && !!candidate.trim(),
  );

  return code?.trim() ?? null;
};

export const isHandledByZnErrorHandler = (error: unknown): boolean =>
  error instanceof HttpErrorResponse &&
  [400, 403, 404, 409, 500].includes(error.status);

